import { FC } from "react";
import { Box, Column, Heading, Text, Button } from "@hightouch/htui";

import { useNavigate } from "src/router";

export const SpaceBlockedPage: FC = () => {
  const navigate = useNavigate();

  return (
    <Column align="center" justify="center" gap={6} height="100%" padding={8}>
      <Column align="center" gap={4} maxWidth="480px" textAlign="center">
        <Heading size="lg">Page not available</Heading>
        <Text color="text.secondary">
          This page is not available in your current view. Some workspace-level
          features are restricted based on your access settings.
        </Text>
        <Box marginTop={4}>
          <Button variant="primary" onClick={() => navigate(-1)}>
            Go back
          </Button>
        </Box>
      </Column>
    </Column>
  );
};
